import { render, staticRenderFns } from "./HowItWorksDappsCenter.vue?vue&type=template&id=7e7297ac&scoped=true&"
import script from "./HowItWorksDappsCenter.vue?vue&type=script&lang=js&"
export * from "./HowItWorksDappsCenter.vue?vue&type=script&lang=js&"
import style0 from "./HowItWorksDappsCenter.vue?vue&type=style&index=0&id=7e7297ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7297ac",
  null
  
)

export default component.exports